import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-resize-observer',
	templateUrl:'./WaResizeObserverPage.html',
	styles: [],
	styleUrls:['./WaResizeObserverPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaResizeObserverPage
{
	mdContent_440 = `\`\`\`java
import com.jwebmp.webawesome.components.observer.WaResizeObserver;
\`\`\``;
}
